// extracted by mini-css-extract-plugin
export default {"container":"Log_container__p3a3x","date":"Log_date__E+xFY","info":"Log_info__bHzr8"};